export const MOBILE_LAYOUT_MAX_WIDTH = 768

/** 窄屏视口（仅用于 CSS 响应式布局，缩小 PC 窗口也会命中） */
export function isNarrowViewport() {
  if (typeof window === 'undefined') return false
  return window.matchMedia(`(max-width: ${MOBILE_LAYOUT_MAX_WIDTH}px)`).matches
}

/**
 * 真实手机/平板浏览（缩小 PC 浏览器窗口不会命中）
 * - 移动 UA，或
 * - 触控主设备 + 窄屏（hover: none + pointer: coarse）
 */
export function isMobileBrowser() {
  if (typeof window === 'undefined') return false
  const ua = navigator.userAgent || ''
  const isMobileUa = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
    || (/iPad/i.test(ua) && 'ontouchstart' in window)
  if (isMobileUa) return true
  return window.matchMedia(
    `(max-width: ${MOBILE_LAYOUT_MAX_WIDTH}px) and (hover: none) and (pointer: coarse)`
  ).matches
}

export function getGlobalHeaderOffset() {
  if (typeof window === 'undefined') return 60
  return window.matchMedia(`(max-width: ${MOBILE_LAYOUT_MAX_WIDTH}px)`).matches ? 96 : 60
}

export const SHOW_MOBILE_GUIDE_EVENT = 'show-mobile-guide'

export function dispatchShowMobileGuide() {
  window.dispatchEvent(new CustomEvent(SHOW_MOBILE_GUIDE_EVENT))
}
